// extracted by mini-css-extract-plugin
export default {"menuContainer":"GpnKMT","VerticalAnchorsMenuTextSkin":"UzdA5y","verticalAnchorsMenuTextSkin":"UzdA5y","link":"AEZNUa","activeAnchor":"PtcFXK","label":"eKWCgb"};